import { Card, CardContent, CardContentProps, CardProps, Box } from '@mui/material';

export const GradientBorderCard = (props: CardProps) => {
    return (
        <Card
            {...props}
            sx={{
                width: '350px',
                backgroundImage: 'linear-gradient(135deg, rgb(10, 38, 147), rgb(1, 207, 254) 73.74%, rgb(242, 211, 205) 100%)',
                borderRadius: '20px',
                padding: '2px',
                ...(props?.sx && props.sx),
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#0C0F21',
                    backgroundImage: 'linear-gradient(135deg, rgba(10, 38, 147, 0.20) 0%, rgba(1, 207, 254, 0.20) 73.74%, rgba(242, 211, 205, 0.20) 100%)',
                    borderRadius: '20px',
                    height: '100%',
                    width: '100%',
                    p: '20px 36px',
                }}
            >
                {props.children}
            </Box>
        </Card>
    );
};

export const StyledCardContainer = (props: CardContentProps) => {
    return (
        <CardContent
            {...props}
            sx={{
                '&.MuiCardContent-root': { p: 0, pt: '24px' },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#A3A5B0',
                ...(props?.sx && props.sx),
            }}
        >
            {props.children}
        </CardContent>
    );
};
